<template>
	<view class="find">
		<!-- 头部导航 -->
		<view class="find_nav">
			<view class="find_nav_hot" @click="toInformation">
				<image src="@/static/images/faxian_ic_zixun@2x.png" mode="widthFix"></image>
				<text class="hot">热门资讯</text>
				<text class="see">发现最新行业动态</text>
			</view>
			<view class="find_nav_list">
				<view class="find_nav_list_item" @click="toActivity">
					<image src="@/static/images/faxian_ic_saishi@2x.png" mode="widthFix"></image>
					<text class="title">活动赛事</text>
					<text class="info">感受咖啡热情</text>
				</view>
				<view class="find_nav_list_item" @click="toExploreShop">
					<image src="@/static/images/faxian_ic_daren@2x.png" mode="widthFix"></image>
					<text class="title">达人探店</text>
					<text class="info">种草好咖啡</text>
				</view>
			</view>
		</view>
		<!-- 列表搜索 -->
		<view class="find_box">
			<view class="find_box_search">
				<view class="find_box_search_cate">
					<view class="find_box_search_cate_item" v-for="(item, index) in cateList" :key="index" @click="i = index">
						<text :class="i === index ? 'activeColor' : ''">{{item.name}}</text>
						<view class="active" v-show="i === index"></view>
					</view>
				</view>
				<view class="find_box_search_sou" @click="toSearch">
					<image src="@/static/icon/ic_search@2x.png" mode="widthFix"></image>
					<text>搜你想看的</text>
				</view>
			</view>
			<view class="find_box_list">
				<shopitem @jump="jump" />
				<shopitem @jump="jump" />
				<shopitem @jump="jump" />
			</view>
		</view>
	</view>
</template>

<script>
	import shopitem from '@/components/ShopItem/index.vue'
	export default {
		data() {
			return {
				i: 0,
				cateList: [
					{
						name: '最新'
					},
					{
						name: '最热'
					},
					{
						name: '关注'
					}
				]
			}
		},
		components: { shopitem },
		methods: {
			jump() {
				uni.navigateTo({
					url: '/pages/eventDetails/index'
				});
			},
			toSearch() {
				uni.navigateTo({
					url: '/pages/discoverySearchPage/index'
				});
			},
			toInformation() {
				uni.navigateTo({
					url: '/pages/information/index'
				});
			},
			toActivity() {
				uni.navigateTo({
					url: '/pages/activity/index'
				});
			},
			toExploreShop() {
				uni.navigateTo({
					url: '/pages/darenExplorationStore/index'
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.find {
		width: 100%;
		padding: 32rpx;
		box-sizing: border-box;
		background-color: #ffffff;
		.find_nav {
			display: flex;
			flex-direction: column;
			.find_nav_hot {
				width: 100%;
				height: 240rpx;
				display: flex;
				flex-direction: column;
				position: relative;
				image {
					width: 100%;
					height: 100%;
				}
				.hot {
					position: absolute;
					top: 28rpx;
					left: 28rpx;
					font-size: 36rpx;
					font-family: PingFang SC-Semibold, PingFang SC;
					font-weight: 600;
					color: #FFFFFF;
				}
				.see {
					position: absolute;
					top: 76rpx;
					left: 28rpx;
					font-size: 24rpx;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #FFFFFF;
				}
			}
			.find_nav_list {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 24rpx;
				.find_nav_list_item {
					flex: 1;
					position: relative;
					image {
						width: 340rpx;
						height: 140rpx;
					}
					.title {
						position: absolute;
						top: 24rpx;
						left: 28rpx;
						font-size: 34rpx;
						font-family: PingFang SC-Semibold, PingFang SC;
						font-weight: 600;
						color: #FFFFFF;
					}
					.info {
						position: absolute;
						top: 70rpx;
						left: 28rpx;
						font-size: 22rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #FFFFFF;
					}
				}
			}
		}
		.find_box {
			width: 100%;
			display: flex;
			flex-direction: column;
			margin-top: 40rpx;
			.find_box_search {
				display: flex;
				align-items: center;
				margin-bottom: 28rpx;
				.find_box_search_cate {
					flex: 1;
					display: flex;
					align-items: center;
					.find_box_search_cate_item {
						flex: 1;
						display: flex;
						align-items: center;
						flex-direction: column;
						text {
							font-size: 28rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #666666;
						}
						.activeColor {
							font-size: 32rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
						.active {
							width: 40rpx;
							height: 4rpx;
							background: #D20A0A;
							border-radius: 12rpx;
							margin-top: 8rpx;
						}
					}
				}
				.find_box_search_sou {
					flex: 1;
					height: 52rpx;
					padding: 0 28rpx;
					box-sizing: border-box;
					background: rgba(232,232,232,0.7);
					border-radius: 32rpx 32rpx 32rpx 32rpx;
					display: flex;
					align-items: center;
					image {
						width: 24rpx;
						height: 24rpx;
						flex-shrink: 0;
						margin-right: 12rpx;
					}
					text {
						font-size: 24rpx;
						font-family: PingFang SC-Medium, PingFang SC;
						font-weight: 500;
						color: #999999;
					}
				}
			}
			.find_box_list {
				width: 100%;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				justify-content: space-between;
			}
		}
	}
</style>